import { IsInt, MinLength, IsNumberString, Length, IsNumber } from 'class-validator';

export class AltaUsuario {
    Documento: string;
    @IsNumberString()
    Contrato: number;
    @Length(1, 30)
    SerieFranumFra: string;
    @MinLength(3)
    CodExplotacion: string;
    ImporteUltimaFactura: number;
    ActualizarSiExiste: boolean;
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/altausuario.entity.ts